class LicenseInfoService {
  loadWeeks(id) {
    return $.get(`${loadWeeksUrl}${id}`);
  }
}

module.exports = new LicenseInfoService();
